module.exports = __webpack_public_path__ + "img/home-img-2.f270815d.webp";